<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot-scope="scope" slot="menuLeft">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_NOTICE_ADD"
            @click.stop="handleAdd()"
            >新增
          </el-button>
          <el-button
            type="warning"
            icon="el-icon-delete"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_NOTICE_DEL"
            @click.stop="handleDel('DELETE_OPTION', '逻辑删除')"
            >删除
          </el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_NOTICE_DEL"
            @click.stop="handleDel('DELETE_OPTION', '物理删除')"
            >物理删除
          </el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_NOTICE_EDIT"
            @click.stop="handleView(scope.row, scope.index)"
            >查看
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-edit"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_NOTICE_EDIT"
            @click.stop="handleEdit(scope.row, scope.index)"
            >编辑
          </el-button>
        </template>
        <template slot-scope="scope" slot="departmentIdForm">
          <el-select v-model="depart" multiple placeholder="请选择">
            <el-option
              v-for="depart in departs"
              :key="depart.id"
              :label="depart.name"
              :value="depart.id"
            >
            </el-option>
          </el-select>
        </template>
        <!-- 超出文本显示...点击查看全部 -->
        <template slot-scope="scope" slot="title">
          <el-tooltip
            class="item"
            effect="light"
            :content="scope.row.title"
            visible-arrow
            placement="top"
          >
            <span>{{ scope.row.title }}</span>
          </el-tooltip>
        </template>
        <!-- 主题图片 -->
        <template slot-scope="scope" slot="coverUrlForm">
          <el-upload
            :multiple="false"
            action="#"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList1"
            :http-request="fnUploadremittanceImg"
            :show-file-list="false"
          >
            <div
              v-if="'' != remittanceImg"
              class="el-upload el-upload--picture-img"
            >
              <img
                class="avue-crud-upload__avatar"
                :src="remittanceImg"
                style="width: 200px;"
              />
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-upload"></i>
            </div>
            <div class="el-upload__tip">
              请上传通告封面图片，只能上传jpg/png图片，且不超过500kb
            </div>
          </el-upload>
        </template>
        <!-- 主题图片表格回显 -->
        <template slot-scope="scope" slot="coverUrl">
          <viewer :images="formmaterImage(scope.row.coverUrl)">
            <img
              v-for="src in formmaterImage(scope.row.coverUrl)"
              :src="src"
              :key="src"
              width="30"
            />
          </viewer>
        </template>
        <!-- 通告内容 -->
        <!-- <template slot-scope="scope" slot="contentForm"> </template> -->
        <!-- 通告内容表格回显 -->
        <!-- <template slot-scope="scope" slot="content">
          <viewer :images="formmaterImage(scope.row.content)">
            <img
              v-for="src in formmaterImage(scope.row.content)"
              :src="src"
              :key="src"
              width="30"
            />
          </viewer>
        </template> -->
        <template slot-scope="scope" slot="departmentId">
          <el-tag v-if="scope.row.departmentName != null">{{
            scope.row.departmentName
          }}</el-tag>
        </template>
      </avue-crud>
      <!-- 富文本预览弹窗 -->
      <el-dialog
        title="公告内容"
        :visible.sync="dialogFormVisible1"
        width="80%"
      >
        <el-form label-width="80px">
          <el-form-item>
            <div v-html="content"></div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="danger" @click="dialogFormVisible1 = false"
            >关 闭</el-button
          >
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { noticeTableOption } from "@/const/salesCloud/noticeOption";
import {
  findNoticeList,
  addNotice,
  editNotice,
  delNotice,
} from "@/api/salesCloud/notice";
import { findDepartmentAll } from "@/api/salesCloud/department";
import { findByLabel, parseParam } from "@/util/util";
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import VueQr from "vue-qr";
import oss from "ali-oss";
import md5 from "js-md5";
// import { get } from "http";
// import { async } from "q";
// import avueUeditor from 'avue-plugin-ueditor'
export default {
  name: "stuff",
  components: {
    VueQr,
    // avueUeditor
  },
  data() {
    return {
      tableOption: noticeTableOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      dialogFormVisible: false,
      tabelObj: {},
      time: "",
      stuffIds: "",
      dismissReason: "",
      currentStatus: [],
      changeStatus: [],
      jobStatus: [],
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      form: {
        //人员变动
        delivery: false,
        reason: "",
        type: [],
        dismissReason: "",
        resource: "",
        desc: "",
      },
      departs: [],
      depart: [],
      remittanceImg: "", //上传的主题图片
      remittanceImgs: [], //上传的富文本图片
      fileList1: [], //主题图片回显
      conttent: "", //富文本
      dialogFormVisible1: false,
      content: "",
    };
  },
  created() {
    // 查询部门
    findDepartmentAll().then((res) => {
      let data = JSON.parse(res.data);
      this.departs = data;
      console.log(this.departs, "所有部门");
    });

    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    formmaterImage(row) {
      let str = new Array();
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    //状态改变确定按钮
    changeStuff() {
      console.log(this);
      /**
       *多选时传参
       **/
      let stuffIds = new Array();
      for (let row of this.$refs.crud.tableSelect) {
        stuffIds.push(row.id);
        // console.log(row)
      }
      stuffIds.push(this.stuffIds);
      const removeDuplicateItems = (arr) => [...new Set(arr)]; //去重
      stuffIds = removeDuplicateItems(stuffIds);
      // console.log(stuffIds.length)
      // console.log(selectStuffIds)
      // console.log(this.changeStatus)
      let jobStatus =
        this.changeStatus == "离职"
          ? "DISMISSION"
          : this.changeStatus == "转正"
          ? "ON_JOB"
          : "";
      this.dismissReason = this.dismissReason.replace(/(^\s+)|(\s+$)/g, "");
      // console.log(this.dismissReason)
      // console.log(jobStatus)
      let params = {
        time: this.time,
        jobStatus,
        dismissReason: this.dismissReason,
      };
      params = parseParam(params);
      console.log(params);
      if (this.changeStatus == "离职" && this.dismissReason == null) {
        this.$message({
          showClose: false,
          message: "请填写离职理由",
          type: "error",
        });
      } else if (jobStatus == "") {
        console.log("请选择变动类型");
        this.$message({
          showClose: false,
          message: "请选择变动类型",
          type: "error",
        });
      } else if (this.time == null) {
        this.$message({
          showClose: false,
          message: "请选择变动时间",
          type: "error",
        });
      }

      if (this.changeStatus == "转正" && this.time) {
        this.dialogFormVisible = false;
      } else if (
        this.changeStatus == "离职" &&
        this.dismissReason &&
        this.time
      ) {
        this.dialogFormVisible = false;
      }
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findNoticeList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findNoticeList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findNoticeList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findNoticeList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    clean() {
      this.depart = [];
      this.remittanceImg = "";
      this.fileList1 = [];
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.clean();
      this.$refs.crud.rowAdd();
    },
    //查看
    handleView(row) {
      //弹出富文本预览窗口
      this.dialogFormVisible1 = true;
      this.content = row.content;
    },
    handleEdit(row, index) {
      this.clean();
      this.depart = row.departmentId.split(",");
      this.remittanceImg = row.coverUrl;
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      findNoticeList(parmas).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        console.log(this.tableData);
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {},
    /**
     * @title 新增的主题图片
     **/

    fnUploadremittanceImg(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList1 = files;
            console.log("图片", this.fileList1);
            console.log("上传成功", results.res.requestUrls[0]);
            let url = results.res.requestUrls[0].split("?");
            this.remittanceImg = url[0];
            this.tableLoading = false;
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },

    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/

    /* handleSave(row, done) {
      var that = this;
      console.log("选择的部门", that.depart);
      row.departmentId = that.depart.join(",");
      row.coverUrl = that.remittanceImg;
      console.log("所有提交数据", row);

      // 将富文本内的所有base64图片转换成文件
      let images = row.content.match(/data:image\/\w+;base64,[^'"]+/g) || [];
      let promises = images.map((image) => {
        return new Promise((resolve, reject) => {
          let img = new Image();
          img.onload = () => {
            let canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            canvas.getContext("2d").drawImage(img, 0, 0);
            canvas.toBlob((blob) => {
              resolve({
                name: md5(image) + new Date().getTime() + ".png",
                data: blob,
              });
            }, "image/png");
          };
          img.onerror = () => {
            reject(new Error("Failed to load image"));
          };
          img.src = image;
        });
      });
      Promise.all(promises)
        .then((files) => {
          // 将文件上传到阿里云OSS，并记录上传后的URL
          let promises = files.map((file) => {
            let storeAs = file.name;
            let fileData = file.data;
            return that.aliClient.put(storeAs, fileData, {}).then((result) => {
              return {
                name: storeAs,
                url: result.url,
              };
            });
          });

          return Promise.all(promises);
        })
        .then((results) => {
          let urls = {};
          // 记录上传后的URL
          results.forEach((result) => {
            urls[result.name] = result.url;
          });

          // 替换富文本中的图片路径
          for (let name in urls) {
            let pattern = new RegExp(
              "<img[^>]*src=[\"']data:image\\/\\w+;base64," +
                name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") +
                "[\"'][^>]*>",
              "g"
            );
            row.content = row.content.replace(pattern, () => {
              return '<img src="' + urls[name] + '">';
            });
          }

          console.log("替换后的富文本", row.content);

          addNotice(row)
            .then((response) => {
              if (response.code == "200") {
                that.$message({
                  showClose: true,
                  message: "添加成功",
                  type: "success",
                });
                that.handleList();
              } else {
                that.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              that.loading = false;
              that.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            })
            .finally(() => {
              done();
            });
        })
        .catch((error) => {
          that.loading = false;
          that.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
    }, */
    guid2() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      );
    },
    base64ImgtoFile(image, name) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          canvas.getContext("2d").drawImage(img, 0, 0);
          canvas.toBlob((blob) => {
            resolve({
              name: name,
              data: blob,
            });
          }, "image/png");
        };
        img.onerror = () => {
          reject(new Error("Failed to load image"));
        };
        img.src = image;
      });
    },
    handleSave(row, done) {
      const that = this;
      console.log("选择的部门", that.depart);
      row.departmentId = that.depart.join(",");
      row.coverUrl = that.remittanceImg;
      console.log("所有提交数据", row);
      let content = row.content;
      let flag = [];
      // 将富文本内的所有base64图片转换成文件
      //var images = row.content.match(/data:image\/\w+;base64,[^'"]+/);
      let array = [];
      while (flag) {
        console.log("flag", flag);
        flag = content.match(/data:image\/\w+;base64,[^'"]+/);
        if (flag) {
          //let obj = {};
          let uuid = that.guid2();
          let obj = that.base64ImgtoFile(flag[0], uuid + ".png");
          array.push(obj);
          content = content.replace(
            new RegExp(/data:image\/\w+;base64,[^'"]+/),
            "http://joinstech-public.oss-cn-shenzhen.aliyuncs.com/" +
              uuid +
              ".png"
          );
        }
      }
      getAliyunPublicToken()
        .then((res) => {
          const data = JSON.parse(res.data);
          const client = new oss({
            region: data.point,
            endPoint: data.point,
            accessKeyId: data.accessKeyId,
            accessKeySecret: data.accessKeySecret,
            Expiration: data.expiration,
            bucket: data.bucketName,
            stsToken: data.securityToken,
          });
          array.map((file) => {
            file.then((file) => {
              console.log("array4", file.name);
              const storeAs = file.name;
              const fileData = file.data;
              return client.put(storeAs, fileData, {}).then((result) => {
                return {
                  name: storeAs,
                  url: result.url,
                };
              });
            });
          });
          row.content = content;
          // row.coverUrl ="";
          // row.coverUrl = row.coverUrl.replace("http://joinstech-public.oss-cn-shenzhen.aliyuncs.com/", "");
          console.log("替换后的富文本", row);
          addNotice(row)
            .then((response) => {
              if (response.code == "200") {
                that.$message({
                  showClose: true,
                  message: "添加成功",
                  type: "success",
                });
                that.handleList();
              } else {
                that.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              that.loading = false;
              that.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            })
            .finally(() => {
              done();
            });
        })
        .catch((error) => {
          that.loading = false;
          that.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          console.log(ids);
          delNotice(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.departmentId = this.depart.join(",");
      row.coverUrl = this.remittanceImg;
      editNotice(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
  },
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
